/* eslint-disable no-nested-ternary */
const DEV_ENVIRONMENTS = {
  dev: 'dev',
  development: 'dev',
  prod: 'prod',
  production: 'prod',
  sandbox: 'sandbox',
  stage: 'stage',
} as const;

export type DevMode = { [K in keyof typeof DEV_ENVIRONMENTS]: (typeof DEV_ENVIRONMENTS)[K] };

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const isValidEnvVal = (value: string | undefined, _callType?: string) =>
  value !== undefined && value !== 'undefined' && value !== '' ? Object.keys(DEV_ENVIRONMENTS).includes(value) : false;

export const RESOLVED_NODE_ENV = isValidEnvVal(process.env?.VITE_NODE_ENV)
  ? process.env?.VITE_NODE_ENV
  : isValidEnvVal(process.env?.CONFIG_NODE_ENV)
  ? process.env?.CONFIG_NODE_ENV
  : 'prod';

export const DEV_MODE = DEV_ENVIRONMENTS[RESOLVED_NODE_ENV as keyof DevMode];

export const generateEnvUrl = (url: string) => {
  // Return if the url includes seamless since we don't need to format it
  if (url.includes('seamless')) return url;
  // return if the URL already includes the dev environment
  if (url.includes(`.${DEV_MODE}.`)) return url;

  const productPath =
    DEV_MODE !== 'prod'
      ? url
          .split('.')
          .map((p, i) => (i === 0 ? `${p}.${DEV_MODE}` : p))
          .join('.')
      : url;

  return productPath;
};
